import createAction from '@wix/communities-blog-client-common/dist/src/services/create-action';
import { parseInstance } from './parse-instance';

export const SET_INSTANCE_VALUES = 'instanceValues/SET';

export const setInstanceValues = createAction(SET_INSTANCE_VALUES);

export const initialiseInstanceValues = instance => dispatch => dispatch(setInstanceValues(parseInstance(instance)));
